export class RouteUtils {
  static cleanedUrlRoute(url: string): string {
    if (url.indexOf('?') > -1) {
      return url.substring(0, url.indexOf("?"));
    } else {
      return url;
    }
  }
}
